import type { PlatformDictionary } from "lib/i18n/types";

export const SITE_ROUTE = "/site";
export const SITE_CHAT_ROUTE = "/site/chat";
export const SITE_DESCRIBE_ROUTE = "/site/describe";
export const SITE_CLAUDE_ROUTE = "/site/claude";
export const SITE_ASSISTANT_REQUEST_ROUTE = "/site/assistant-request";
export const READY_DESIGNS_ROUTE = "/site/designs";

export const readyDesignRoute = (id: string) => `${READY_DESIGNS_ROUTE}/${encodeURIComponent(id)}`;

// The breadcrumb title for a "Мій сайт" page, from the path segments after `site`.
export function getSiteSectionTitle(
  segments: readonly string[],
  translations: PlatformDictionary["sitePage"]
) {
  if (segments[0] === "chat") return translations.chat.title;
  if (segments[0] === "designs") return translations.designs.title;
  return translations.title;
}
